import {KeycloakInitOptions} from 'keycloak-js';

/**
 * Опции инициализации Keycloak на старте приложения.
 *
 * Для публичного просмотра onLoad не задаём: 'login-required' редиректит анонимного
 * посетителя на форму входа Keycloak прямо внутри keycloak.init(), то есть ещё до
 * старта роутинга — публичная ссылка не успела бы открыться.
 */
export function buildKeycloakInitOptions(publicView: boolean): KeycloakInitOptions {
  return {
    checkLoginIframe: false,
    ...(publicView ? {} : {onLoad: 'login-required' as const}),
    redirectUri: window.location.href.split('#')[0],
    pkceMethod: 'S256',
  };
}
